import React, {useEffect} from "react";
import {observer} from "mobx-react";
import classNames from "classnames";
import {IStickyHandler} from "../../../sticky-handler/sticky-handler.interface";
import {LiveCasinoFilterButtonsBox} from "./boxes/live-casino-filter-buttons/live-casino-filter-buttons.box";
import {STICKY_NAVBAR} from "./css-constants";
import {LiveCasinoNavbarBox} from "./boxes/live-casino-navbar/live-casino-navbar.box";
import {LiveCasinoArenaNavbarButtonProps} from "./live-casino-arena-navbar-button.component";
import {ThemeProvider} from "styled-components";
import {
  LiveTableTabConfiguration
} from "../../../../services/live-table-feeds-service/live-table-feeds.service.interface";
import {LobbyHeaderTitleBox} from "../../../lobby-header/boxes/title/lobby-header-title.box";
import {CyClass} from "../../../../../common/cy-classes";
import {LobbyHeaderTitleContainerBox} from "../../../lobby-header/boxes/container/lobby-header-title.container.box";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {withServices} from "../../../../react-hooks/with-services";

interface LiveCasinoArenaNavbarProps extends ComponentServicesPick<'header'>{
  title?: string;
  configs: LiveTableTabConfiguration[];
  stickyHandler: IStickyHandler;
  FilterButtonComponent: React.ComponentType<LiveCasinoArenaNavbarButtonProps>;
}

const ComponentBody: React.FC<LiveCasinoArenaNavbarProps> = observer((props) => {
    const services = useServices();
    useEffect(() => {
        return () => props.stickyHandler && props.stickyHandler.dispose();
    }, [props.stickyHandler]);

    const _onFilterClicked = async (tabId: string)  => {
        await services.liveTableFeeds.setCurrentArenaTab(tabId);
    };


    const FilterButtonComponent = props.FilterButtonComponent || React.Fragment;
    return (
        <ThemeProvider theme={services.theme.mainContentTheme}>
            <LiveCasinoNavbarBox
                className={classNames("cy-live-casino-navbar", {
                    [STICKY_NAVBAR]: props.stickyHandler.isSticky,
                })}
                stickOffset={props.header.headerHeight}
            >
                {props.title ? <LobbyHeaderTitleContainerBox>
                    <LobbyHeaderTitleBox className={CyClass("cy-lobby-header-title")}>
                <span style={{flex: "0 0 auto"}}>
                  {services.translation.translate(props.title)}
                </span>
                    </LobbyHeaderTitleBox>
                </LobbyHeaderTitleContainerBox> : null}
                <LiveCasinoFilterButtonsBox
                    className={"cy-live-casino-filter-buttons"}
                >
                    {props.configs.map((tabConfig) => {
                        return (
                            tabConfig.gridConfiguration.gamesId.length === 0 ? null :
                                <FilterButtonComponent
                                    key={tabConfig.headerConfiguration.filter}
                                    labelTranslationKey={tabConfig.gridConfiguration.title}
                                    filter={tabConfig.headerConfiguration.filter}
                                    onClick={async () => await _onFilterClicked(tabConfig.headerConfiguration.filter)}
                                    seoPage={tabConfig.headerConfiguration.seoPage}
                                    isActiveTab={tabConfig.headerConfiguration?.filter?.toLowerCase() === services.liveTableFeeds.currentArenaTabConfiguration?.headerConfiguration?.filter?.toLowerCase()}
                                />
                        );

                    })}
                </LiveCasinoFilterButtonsBox>
            </LiveCasinoNavbarBox>
        </ThemeProvider>
    );
})


export const LiveCasinoArenaNavbar = withServices(ComponentBody, ['header']);